import TwoFactorForm from './two_factor_form.vue'
export default TwoFactorForm
